<template>
  <avz-properties />
</template>

<script>
import Properties from '@/components/Properties'

export default {
  components: {
    'avz-properties': Properties
  }
}
</script>
